import React from 'react';
import PropTypes from 'prop-types';

const Slide = (props) => {
  const {
    id,
    onClick,
    active,
    style,
    content,
  } = props;

  return (
    <div
      role="button"
      onClick={() => onClick(id)}
      onKeyDown={() => onClick(id)}
      tabIndex="0"
      className={`slide${active ? ' is-active' : ''}`}
      style={style}
    >
      {content}
    </div>
  );
};

Slide.propTypes = {
  onClick: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  active: PropTypes.bool,
  style: PropTypes.instanceOf(Object),
  content: PropTypes.instanceOf(Array).isRequired,
};

Slide.defaultProps = {
  active: false,
  style: {},
};

export default Slide;
